import {Component, OnInit} from '@angular/core';
import { TipoLotesVacunas } from 'src/app/models/tipo-lotes-vacunas';

import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  selector: 'app-lista-lotes-vacunas',
  templateUrl: './lista-lotes-vacunas.component.html',
  styleUrls: ['./lista-lotes-vacunas.component.css']
})
export class ListadoLotesVacuna implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Lotes de vacunas',
      routerLink: '/vacunas'
    }
  ];

  tipos: TipoLotesVacunas[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposLotesVacunas().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        // Seleccionando inscripcion de contratos de la funcion getTiposPoderes
        const descripcion = p.descripcion.toString();
        array.push(p);
      });
      this.tipos = array;
    });
  }
}
